import {
	AddTwoFAMethodResponse,
	AuthRepository,
	TwoFactorMethodTypeOptions
} from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { enumValueObject } from '@contexts/shared/domain';

export type Add2FAMethodInput = {
	methodType: TwoFactorMethodTypeOptions;
};

export type Add2FAMethodUseCase = UseCase<Add2FAMethodInput, AddTwoFAMethodResponse>;

export function add2FAMethodBuilder(authRepository: AuthRepository): Add2FAMethodUseCase {
	return async function add2FAMethod(input: Add2FAMethodInput): Promise<AddTwoFAMethodResponse> {
		const methodType = enumValueObject<TwoFactorMethodTypeOptions, TwoFactorMethodTypeOptions>()
			.setEnum(TwoFactorMethodTypeOptions)
			.validate('methodType', input.methodType);

		return authRepository.addTwoFactorMethod(methodType);
	};
}
